import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class branchSelectListCtrl implements IController {
  selectedId: any;
  optionIds: any;
  excludeIds: any;
  onChange: Function;

  private branchesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $branches, private $infiniteScroll) {
  }

  $onInit() {
    this.branchesRef = this.$branches();
    this.loadLimit = 20;

    this.branchesRef.$query(this._getPaginationParams());
    this.infiniteScroll = this.$infiniteScroll(this.branchesRef, this.loadLimit, this._getInfiniteScrollConfig());
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.branchesRef.$query(this._getPaginationParams())
      .then(() => {
        this.infiniteScroll.reload(this._getInfiniteScrollConfig());
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getPaginationParams() {
    return {
      limit: this.loadLimit,
      sort: 'name,asc'
    };
  }

  private _getInfiniteScrollConfig() {
    return {
      data: this._getFilterPayload(),
      getFullData: true
    };
  }

  private _getFilterPayload() {
    return {
      query: this.queryString,
      isInactive: false
    };
  }
}

angular
  .module('bringoz.admin.branches')
  .component('branchSelectList', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./branch-select-list.html').default,
    controller: branchSelectListCtrl
  });
